import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/layouts/default.vue").then(m => m.default || m))
}